import React, { useState } from "react";
import { ButtonGroup, Menu, MenuItem } from "@material-ui/core";
import MoreVert from "@material-ui/icons/MoreVert";

import { GreenButton } from "../../../../../components/form-controls/button/green-button/green-button.component";
import { GreenMoreButton } from "../../../../../components/form-controls/button/green-more-button/green-more-button.component";
import { withShowIf } from "../../../../../components/with-show-if/with-show-If.component";

import { BriefHeaderActionsProps } from "./brief-header-actions.props";

export const BriefHeaderActions = withShowIf((props: BriefHeaderActionsProps) => {
  const [extraActionsAnchor, setExtraActionsAnchor] = useState<null | HTMLElement>(null);
  const extraActionsAnchorOpen = Boolean(extraActionsAnchor);

  const filteredActions = props.extraActions.filter((action) => action.show !== false);

  const closeExtraActionsMenu = () => {
    setExtraActionsAnchor(null);
  };

  const openExtraActionsMenu = (event: React.MouseEvent<HTMLElement>) => {
    setExtraActionsAnchor(event.currentTarget);
  };

  const MoreButtonText = "More Options";

  return (
    <>
      <ButtonGroup style={{ marginRight: "15px" }}>
        <GreenButton
          disabled={props.isSaveDisabled}
          onClick={
            props.formRef.current.handleSubmit && props.formRef.current.handleSubmit(props.onSubmit)
          }
          title="Save Changes"
        >
          Save
        </GreenButton>
        {filteredActions.length && (
          <GreenMoreButton
            disabled={!props.loaded || props.isSaveDisabled}
            onClick={openExtraActionsMenu}
            onMouseOver={openExtraActionsMenu}
            title={MoreButtonText}
          >
            <MoreVert />
          </GreenMoreButton>
        )}
      </ButtonGroup>
      {!!filteredActions.length && (
        <Menu
          anchorEl={extraActionsAnchor}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          getContentAnchorEl={null}
          keepMounted
          MenuListProps={{ onMouseLeave: closeExtraActionsMenu }}
          onClose={closeExtraActionsMenu}
          open={extraActionsAnchorOpen}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {filteredActions.map(({ action, label }, index) => (
            <MenuItem
              key={index}
              onClick={() => {
                action && action();
                closeExtraActionsMenu();
              }}
            >
              {label}
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
});
